import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { IPurchaseInvoicesStatusEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<IPurchaseInvoicesStatusEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.purchaseInvoicesStatus");

export const purchaseInvoicesStatus = {
  ...getAllApis,
};
